// import React from 'react' // Not needed in React 17+
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import CodePlayground from './components/CodePlayground';
import TypingChallenge from './components/TypingChallenge';
import GitHubActivity from './components/GitHubActivity';
import TechStackExplorer from './components/TechStackExplorer';
import NewsSection from './components/NewsSection';

import Contact from './components/Contact';
import AdminRoute from './components/AdminRoute';
import './App.css';

// Home page component
const HomePage = () => {
  console.log('Rendering HomePage component');
  
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Skills />
        <CodePlayground />
        <TypingChallenge />
        <GitHubActivity />
        <TechStackExplorer />
        <Contact />
        <NewsSection />
      </main>
      <footer className="py-8 text-center text-white">
        <p>© {new Date().getFullYear()} Harsh Trivedi | Trifusion Solutions. All rights reserved.</p>
      </footer>
    </>
  );
};

function App() {
  console.log('Rendering App component');
  
  useEffect(() => {
    // Initialize dark mode based on user preference
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark');
    }
    
    // Log that the app has mounted
    console.log('App component mounted');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/user" element={<AdminRoute />} />
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
